import { isIos } from '../helpers/utility'
import { ANDROID_BRIDGE } from './android'
import { IOS_BRIDGE } from './iOS'

export const getFCMTokenBridge = async () => {
  if (isIos()) {
    return await IOS_BRIDGE.getFCMToken()
  } else if (ANDROID_BRIDGE.getFCMToken) {
    return await ANDROID_BRIDGE.getFCMToken()
  }
  return null
}

export const saveFCMTokenBridge = (token = '') => {
  if (isIos()) {
    // unhandled error
    IOS_BRIDGE.saveFCMToken(token).catch((e) => {})
  } else if (ANDROID_BRIDGE.saveFCMToken) {
    ANDROID_BRIDGE.saveFCMToken(token).catch((e) => {})
  }
}

export const openUrlInBrowser = (url, callback = () => {}) => {
  if (isIos()) {
    IOS_BRIDGE.openUrlInBrowserInIos(url, callback)
  } else if (ANDROID_BRIDGE.openUrlInBrowser) {
    ANDROID_BRIDGE.openUrlInBrowser(url, callback)
  } else {
    window.open(url, '_target')
  }
}
